import { createRouter, createWebHistory } from '@ionic/vue-router';
//import { RouteRecordRaw } from 'vue-router'; //REMOVED 2022-11-23
import HomePage from '../views/HomePage.vue'
import Profile from '../views/Profile.vue'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Documentation from '../views/Documentation.vue'
import api from '../services/api'

function getStoredUser() {
  const userJson = localStorage.getItem('user');

  if (!userJson) {
    return null;
  }

  try {
    return JSON.parse(userJson);
  } catch (error) {
    console.error('Error parsing JSON:', error);
    localStorage.removeItem('user');
    return null;
  }
}

function hasAuthData(user) {
  return Boolean(user && user.accessToken && user.refreshToken && Array.isArray(user.role));
}

function parseJwtPayload(token) {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) {
      return null;
    }

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch (_error) {
    return null;
  }
}

function isAccessTokenExpired(token) {
  const payload = parseJwtPayload(token);
  if (!payload || !payload.exp) {
    return false;
  }

  return Date.now() >= payload.exp * 1000;
}

const routes/*: Array<RouteRecordRaw>*/ = [
  {
    path: '/',
    redirect: () => {
      const loggedIn = getStoredUser();
      return loggedIn ? '/usertunes' : '/tunes';
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: () => import('../views/Statistics.vue')
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/register",
    component: Register,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile
  },
  {
    path: '/documentation',
    name: 'Documentation',
    component: Documentation
  },
  {
    path: '/tunes',
    name: 'Tunes',
    component: () => import("../views/Tunes")
  },
  {
    path: "/tunes/:id",
    name: "Tune",
    component: () => import("../components/Tune")
  },
  {
    path: '/usertunes',
    name: 'UserTunes',
    component: () => import("../views/UserTunes")
  },
  {
    path: "/usertunes/:id",
    name: "usertune-details",
    component: () => import("../components/UserTune")
  },
  {
    path: '/tunebooks',
    name: 'Tunebooks',
    component: () => import("../views/Tunebooks")
  },
  {
    path: "/tunebooks/:id",
    name: "tunebook-details",
    component: () => import("../views/Tunebook")
  },
  {
    path: "/add",
    name: "add",
    //component: () => import("../components/AddTune")
    component: () => import("../views/AddTune")
  },
  {
    path: '/groups',
    name: 'groups',
    component: () => import('../views/groups/Groups.vue')
  },
  {
    path: "/groups/:id",
    name: "group-details",
    component: () => import('../views/group/Group.vue')
  },
  {
    path: '/playlists',
    name: 'playlists',
    component: () => import('../views/PlayLists.vue')
  },
  {
    path: '/events',
    name: 'events',
    component: () => import('../views/Events.vue')
  },
  {
    path: '/events/:id',
    name: 'event-details',
    component: () => import('../views/events/EventDetail.vue')
  },
  {
    path: '/sessions',
    name: 'sessions',
    component: () => import('../views/SessionList.vue')
  },
  {
    path: "/sessions/:id",
    name: "session-details",
    component: () => import("../components/Session.vue")
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../components/UserList.vue')
  },
  {
    path: "/users/:id",
    name: "user-details",
    component: () => import('../views/User.vue')
  },
  {
    path: "/Musik/:id",
    name: "Musik",
    component: () => import("../views/Musik.vue")
  },
  {
    path: '/settings',
    name: 'settings',
    // lazy-loaded
    component: () => import('../views/Settings.vue')
  },
  {
    path: "/forgotpassword",
    name: "forgotpassword",
    component: () => import("../views/ForgotPassword")
  },
  {
    path: "/resetpassword",
    name: "resetpassword",
    component: () => import("../views/ResetPassword")
  },
  {
    path: "/confirmuser",
    name: "confirmuser",
    component: () => import("../views/ConfirmUser")
  },
  {
    path: "/mod",
    name: "moderator",
    component: () => import("../views/BoardModerator")
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("../views/BoardAdmin")
  },
  {
    path: "/messages",
    name: "messages",
    component: () => import("../views/Messages")
  },
  {
    path: "/playlists/:id",
    name: "playlist",
    component: () => import("../views/PlayList")
  },
  {
    path: '/musicians',
    name: 'Musicians',
    component: () => import("../views/Musicians.vue")
  },
  {
    path: '/musicians/:id',
    name: 'Musician',
    component: () => import("../views/Musician.vue")
  },
  //ROUTES FOR BUY PREMIUM
  /*{
    path: '/premium-success',
    name: 'PremiumSuccess',
    component: () => import("../views/PremiumSuccess.vue")
  },
  {
    path: '/premium-cancel',
    name: 'PremiumCancel',
    component: () => import("../views/PremiumCancel.vue")
  },*/
  //ROUTES FOR MANUAL TESTING SYSTEM
  {
    path: '/test-center',
    name: 'TestCenter',
    component: () => import("../views/TestCenter.vue")
  },
  {
    path: '/test-cases',
    name: 'TestCases',
    component: () => import("../views/TestCases.vue")
  },
  {
    path: '/report-bug',
    name: 'ReportBug',
    component: () => import("../views/ReportBug.vue")
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('../views/SupportFolkwiki.vue')
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

//Added 2023-03-13 verkar funka
router.beforeEach(async (to, from, next) => {
  const publicPages = ['/login', '/register', '/home', '/tunes', '/tunes/:id', '/forgotpassword', '/resetpassword', '/confirmuser', '/Musik', '/Musik/:id', '/tunebooks', 'tunebooks/:id', '/musicians', '/musicians/:id', '/statistics', '/documentation', '/support'];
  const strippedPath = to.path.substring(0, to.path.lastIndexOf('/'));
  const authRequired = !(publicPages.includes(to.path) || publicPages.includes(strippedPath));

  let userObj = getStoredUser();

  if (userObj && !hasAuthData(userObj)) {
    localStorage.removeItem('user');
    userObj = null;
  }

  if (authRequired && userObj && isAccessTokenExpired(userObj.accessToken)) {
    try {
      const refreshResponse = await api.post('/auth/refreshtoken', {
        refreshToken: userObj.refreshToken,
      });

      if (refreshResponse?.data?.accessToken) {
        userObj = { ...userObj, accessToken: refreshResponse.data.accessToken };
        localStorage.setItem('user', JSON.stringify(userObj));
      } else {
        throw new Error('No access token in refresh response');
      }
    } catch (_error) {
      localStorage.removeItem('user');
      userObj = null;
    }
  }

  const loggedIn = Boolean(userObj);
  //console.log(userObj)
  //console.log(!userObj.role.includes('ROLE_ADMIN'));
  //console.log(to.path);
  //console.log(loggedIn.role.includes('ROLE_MODERATOR'));

  // trying to access a restricted page + not logged in
  // redirect to start page
  if (authRequired && !loggedIn) {
    next('/tunes');
  }
  else if (loggedIn && !userObj.role.includes('ROLE_MODERATOR') && to.path == '/mod') {
    next('/profile')
  }
  else if (loggedIn && !userObj.role.includes('ROLE_ADMIN') && to.path == '/admin') {
    next('/profile')
  }
  else {
    next();
  }
});
//End addition of router guard

export default router
